
import { g_listOrigin, activeList } from "../core/variables-global.js";
import { fields, simpleSearchLabels } from "../core/l10n.js";
import helpers from "../utils/helpers.js";

function simpleSearchResult() {

  /**
   *
   */
  const displayResult = (item, container, lang) => {
    console.log("Displaying search result:", item, container, lang);
    container.innerHTML = ""; // Efface tout le contenu précédent
    const resultElement = document.createElement("div");
    resultElement.className = "result";

    let resultHTML = `
    <div class="result-header">
      <h3 class="hq-titre4 hq-mb-16">${simpleSearchLabels.votreTermo.label[lang]}</h3>
    </div>
    <div class="hq-grid hq-grid-cols-4 sm:hq-grid-cols-12">
      <div class="hq-col-span-4 sm:hq-col-span-6 md:hq-col-span-4">
        <div class="result-content">`;

    fields.forEach(({ key_neep, key_es, label, label_es, suffix = ""}) => {
      let key = (g_listOrigin === "es") ? key_es : key_neep;

      const suffixValue = typeof suffix === 'object' ? (suffix[lang] || "") : suffix;
      if (["puissance","capacity"].some(word => key.includes(word)) && item[key]) {
        resultHTML += `
        <div class="result-item-row hq-mb-8">
          <div class="result-item-label">${label[lang]}</div>
          <div class="result-item-value">${helpers.formatThousand(item[key])}${suffixValue}</div>
        </div>`;

      } else if (["haut_rendement","cold_climate"].some(word => key.includes(word)) && item[key]) {
        resultHTML += `
        <div class="result-item-row hq-mb-8"  >
          <div class="result-item-label">${ (g_listOrigin === "es") ? label_es[lang] : label[lang]}</div>
          ${["OUI", "YES"].map(s => s.toLowerCase()).includes(item[key].toLowerCase()) ?
            `<div class="result-item-value">${lang === "fr" ? "Oui" : "Yes"}</div>` :
            `<div class="result-item-value">${lang === "fr" ? "Non" : "No"}</div>`
          }
        </div>`;

      } else if (item[key]) {
        resultHTML += `
        <div class="result-item-row hq-mb-8">
          <div class="result-item-label">${label[lang]}</div>
          <div class="result-item-value">${item[key]}</div>
        </div>`;
      } else {
        resultHTML += ``;
      }
    });

    // Gestion des aides financières avec label conditionnel/Subvention et Bonification
    /*
    proprio-habitation-existante/proprio-maison: TTG_AF_EffAlone
    proprio-calfeutrage : N/A
    null / office-habitation : TTG_Ext2
    entreprenur-maison-neuve/entrepreneur-maison : TTG_AF_Maison1
    entrepreneur-nouvelle-construction-multiplex/entrepreneur-plex: TTG_AF_Multi1 / TTG_AF_Multi4
    */


    const aideTemp = {
      "proprio-maison": {
        "neep": ["aide_financiere_a"],
        "es": ["TTG_AF_EffAlone"]
      },
      "proprio-calfeutrage": {
        "neep": ["aide_financiere_a"],
        "es": [null]
      },
      "entrepreneur-maison": {
        "neep": ["aide_financiere_a"],
        "es": ["TTG_AF_Maison1"]
      },
      "entrepreneur-plex": {
        "neep": ["aide_financiere_a", "aide_financiere_b"],
        "es": ["TTG_AF_Multi1", "TTG_AF_Multi4"]
      }/*,
      "office-habitation": {
        "neep": ["aide_financiere_a"],
        "es": ["TTG_Ext2"]
      }*/
    };

    const aideKeys = aideTemp[activeList.name]?.[g_listOrigin];
    if (aideKeys) {
      const hasAideA = item[aideKeys[0]];
      const hasAideB = item[aideKeys[1]];
      const bothAides = hasAideA && hasAideB;

      if (hasAideA) {
        const label = item["program_fecc_admissible"] === "VRAI" ? simpleSearchLabels.subvention.label[lang] : bothAides ? simpleSearchLabels.aideFinanciereEff.label[lang] : simpleSearchLabels.aideFinanciere.label[lang];
        resultHTML += `
        <div class="result-financial-aid">
          <div class="result-item-label">${label}</div>
          <div class="result-item-value">${helpers.formatCurrency(hasAideA)}</div>
        </div>`;
      }

      if (hasAideB) {
        const label = bothAides ? simpleSearchLabels.aideFinanciereOpt.label[lang] : simpleSearchLabels.aideFinanciere.label[lang];
        resultHTML += `
        <div class="result-financial-aid">
          <div class="result-item-label">${label}</div>
          <div class="result-item-value">${helpers.formatCurrency(hasAideB)}</div>
        </div>`;
      }

      // Subventions
      if (item["program_fecc_admissible"] === "VRAI") {
        resultHTML += `
        <div class="result-financial-aid">
          <div class="result-item-label">${simpleSearchLabels.bonification.label[lang]}</div>
          <div class="result-item-value">${helpers.formatCurrency(item["TTG_Ext5"]-item["TTG_AF_EffAlone"])}</div>
        </div>`;
      }
    }

    resultHTML += `</div></div></div>`;
    resultElement.innerHTML = resultHTML;
    container.appendChild(resultElement);
  };

  return {
    displayResult
  };
};

window.simpleSearchResult = simpleSearchResult();
export default window.simpleSearchResult;
